import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { api, Invoice, Session } from './api';

// Shared invoice-list cache (terbebas catalogSlice pattern): tab switches
// render the cached list instantly while a refetch runs in the background.

interface InvoicesState {
  list: Invoice[];
  loaded: boolean;
  loading: boolean;
  error: string;
}

const initialState: InvoicesState = { list: [], loaded: false, loading: false, error: '' };

export const fetchInvoices = createAsyncThunk(
  'invoices/fetch',
  async (session: Session) => {
    const res = await api(session).get('/admin/invoices');
    return res.data.invoices as Invoice[];
  }
);

const invoicesSlice = createSlice({
  name: 'invoices',
  initialState,
  reducers: {
    // A later login may be a different user — never let its first paint show
    // the previous session's cached list.
    resetInvoices: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoices.pending, (state) => { state.loading = true; state.error = ''; })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loaded = true;
        state.loading = false;
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Gagal memuat invoice';
      });
  },
});

export const { resetInvoices } = invoicesSlice.actions;
export default invoicesSlice.reducer;
